import React, {useEffect} from 'react'
import RootRouteAuthenticationAsync from './RootRouteAuthenticationAsync.js'
import RootRouteVerifyEmailAsync from './RootRouteVerifyEmailAsync.js'
import Loading from './Loading.js'
import useAuth from '../hooks/useAuth.js'
import useContextUser from '../hooks/useContextUser.js'

const PrivateRoute = ({as: Authenticated, ...props}) => {
  const {user, hasAuthState, isAuthenticated} = useAuth()
  const [dbUser] = useContextUser()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [props, hasAuthState, isAuthenticated])

  if (!hasAuthState) return <Loading />

  if (isAuthenticated) {
    if (!dbUser) return <Loading />
    if (!user.emailVerified) return <RootRouteVerifyEmailAsync />
    return <Authenticated {...props} />
  }

  return <RootRouteAuthenticationAsync />
}

export default PrivateRoute
